import { render, staticRenderFns } from "./PostulacionForm.vue?vue&type=template&id=0c86886e&scoped=true&"
import script from "./PostulacionForm.vue?vue&type=script&lang=js&"
export * from "./PostulacionForm.vue?vue&type=script&lang=js&"
import style0 from "./PostulacionForm.vue?vue&type=style&index=0&id=0c86886e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86886e",
  null
  
)

export default component.exports